import React from "react";
import headerBackgroundImage from "./card-background-2.png";

function Lagacy() {
  return (
    <div
      className="py-8"
      style={{ backgroundImage: `url(${headerBackgroundImage})` }}
    >
      {/* <div>
                <img className='w-full' src='newimage/banner/aboutBrother.svg'></img>
            </div> */}
      <div>
        {/* <h1 className='text-center font-medium font-serif xs:text-xl md:text-4xl xs:pt-4 md:pt-10'> THE SATGURU TRADITION  </h1> */}
        {/* <div className="p-2 mx-[28%] items-center flex-col justify-center font-serif text-center text-blue-800 text-2xl bg-[aliceblue] rounded-full">
          <div className="h-[2px] my-auto mx-2 w-20 bg-blue-800 inline-block"></div>
          THE SATGURU TRADITION
          <div className="h-[2px] my-auto w-20 bg-blue-800 inline-block mx-2"></div>
        
        </div> */}
 <h2 className="border-b-2 border-[gainsboro] w-[35%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] rounded-2xl">
 THE  SATGURU  TRADITION
      </h2>
        {/* <div className='w-40 h-1.5 mt-3 bg-blue-800 rounded-lg mx-auto'></div> */}
        <h4 className="text-center font-serif text-[18px] lg:w-[1000px] mx-auto pt-3 pb-4 border-b-2 border-gray-200">
          From time immemorial, the relationship of a Teacher and Disciple has
          been the most integral part of the process of learning and
          enlightenment. Imagine, even in the so-called modern times, we try and
          send our children to the best possible educational institution, so
          that they receive the most authentic knowledge and experience from a
          discerning set of teachers. Such is the importance of a true teacher,
          across all realms of time, subject and circumstance; highest of course
          when it relates to questions of soul, oversoul and purpose of life.
          The same being emphasized and endorsed by various saints, sages and
          scriptures from time to time.{" "}
        </h4>

        <div className="xs:grid-cols-1 pb-4 grid md:grid-cols-1">
          {/* <div className=' col-span-1'>
                        <img src="image/home/legacy-2.jpg" className=' w-[80%]  mx-auto'></img>
                    </div> */}
          <div className=" px-20 col-span-1">
            {/* <h1 className='  font-medium xs:text-xl md:text-3xl xs:pt-4 pb-4'> Our lagacy</h1> */}
            {/* <div className='border-b-2 border-blue-800 w-24'></div> */}
            <div className="  pt-4">
              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex">
                <img
                  src="image/lagacy/Baba-Buta-Singh-Ji-Blue.jpg"
                  alt="s"
                ></img>
                <h3 className="my-auto mx-8 font-bold">
                  BABA BUTA SINGH JI MAHARAJ (1873-1943)
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                Baba Buta Singh Ji was born in Hadwal village of present-day
                Pakistan. He was spiritually inclined since childhood and had a
                deep fondness for holy scriptures. Compassionate and kind, he
                was a seeker of the eternal truth. In 1913, during a
                congregation, while he was singing a spiritual hymn, tears
                rolled down from his eyes. Looking at him, Bhai Sahib Kahan
                Singh Ji asked Buta Singh Ji- “Do you know the one you are
                calling? Only knowing him in absoluteness can actually make your
                prayers meaningful” Baba Buta Singh Ji immediately realized that
                he had found a true guide and mentor. He received God-Knowledge
                (Brahmgyan) from Kahan Singh Ji right there. Thereafter, for 14
                long years he travelled all across to spread the light of truth.
                In 1929, he established the Sant Nirankari Mission. Before his
                merger with the almighty in 1943 at Kohmari, Baba Buta Singh Ji
                handed over the responsibility of the mission to his discerning
                disciple, Avtar Singh ji.
              </p>
              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex mt-10">
                <img
                  src="image/lagacy/Baba-Avtar-Singh-Ji-Blue.jpg"
                  alt="s"
                ></img>
                <h3 className="my-auto mx-8 font-bold">
                  BABA AVTAR SINGH JI MAHARAJ (31st DEC 1899 – 17th SEP 1969)
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                Baba Avtar Singh Ji was born in Latifal village of present-day
                Pakistan. He was honest, hard-working and extremely religious by
                nature, oblivious though, of the eternal truth. He was blessed
                with the true awareness of the formless, when in May 1929 he met
                Baba Buta Singh ji. Since then, Avtar Singh ji dedicated his
                entire life to his Satguru (True Master). In 1943, Baba Buta
                Singh Ji handed over the baton of truth to Baba Avtar Singh Ji,
                before leaving his mortal form. Baba Avtar Singh ji was
                addressed as ‘Shahenshah Ji’ by his devotees, with affection and
                faith. After the 1947 Indo-Pak partition, Baba Avtar Singh Ji
                established the Sant Nirankari Mandal in Delhi, India, providing
                an effective administrative structure to run the activities of
                the rapidly expanding mission. He blessed mankind with the
                profound message through the Sampuran Avtar Vani. His remarkable
                contributions also include educating and empowering people to
                break the chains of ritualism and superstitions. His
                far-sightedness, incredible courage and conscientiousness
                continued to inspire thousands of devotees. In 1962, Baba Avtar
                Singh ji entrusted mission’s responsibility to Baba Gurbachan
                Singh Ji, deciding to lead the rest of his life as a normal
                devotee. For the next around seven years, he lived his life with
                complete surrender in the lotus feet of his Satguru Baba
                Gurbachan Singh Ji, before merging with the almighty in 1969.
              </p>
              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex mt-10">
                <img src="image/lagacy/Mata-Budwanti-Ji-Blue.jpg" alt="s"></img>
                <h3 className="my-auto mx-8 font-bold">
                  JAGATMATA BUDDHWANTI JI
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                Jagatmata Ji, the honorable wife of Shahenshah Baba Avtar Singh
                Ji will always be remembered as a motherly figure who cared for
                the devotees of the mission, before and above her own children.
                Her sacrifice and surrender to the word of satguru, stand out as
                inspiration of faith and devotion in the history of Nirankari
                Mission. Jagatmata ji, despite being the wife of Shahenshah ji,
                always remained humble and served the sadh-sangat with selfless
                dedication. Her upbringing and values were necessarily passed on
                to her children including Baba Sajjan Singh ji and Baba
                Gurbachan Singh ji, who contributed to shape up and strengthen
                the mission in their own time and capacity. Jagatmata ji will
                continue to be an inspiration of sewa for generations to come.
              </p>
              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex mt-10">
                <img
                  src="image/lagacy/Baba-Gurubachan-Singh-Ji-Blue.jpg"
                  alt="s"
                ></img>
                <h3 className="my-auto mx-8 font-bold">
                  BABA GURBACHAN SINGH JI MAHARAJ (10th DEC 1930 – 24th APRIL
                  1980)
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                Baba Gurbachan Singh Ji was born in the family of Baba Avtar
                Singh Ji and Mata Budhwanti Ji, in Peshawar, a city in present
                day Pakistan. He was quiet, simple and watchful by nature since
                his childhood. During the turbulent times of Indo-Pak partition,
                he served selflessly at the Wah refugee camp, which impressed
                the administrators so much that they handed over the
                responsibility of the entire camp to Gurbachan Singh Ji. He was
                married to Kulwant Kaur Ji, who was later adorned with the title
                of ‘Rajmata’ by Shahenshah ji. Baba Gurbachan Singh Ji took over
                the spiritual responsibility of leading the mission in 1962, and
                travelled extensively to spread the light of truth, love and
                peace across the world. He also initiated & executed numerous
                social upliftment programs in the fields of education, health
                and empowerment. Major revolutionary steps like mass marriages,
                abstinence from intoxicants and setting up of schools & colleges
                were taken up by Baba Gurbachan Singh Ji. His able
                administration, motivation, guidance, simple living and social
                awareness inspired one and all. With the rising popularity of
                the mission, the opposition also started to rise. Many efforts
                were made by the evil minded to hinder the momentum of the
                mission. In one such sinful incident, Baba Gurbachan Singh Ji
                had to lay his life for humanity on 24th April 1980.
              </p>
              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex mt-10">
                <img src="image/lagacy/Raj-Mata-Ji-Ji-Blue.jpg" alt="s"></img>
                <h3 className="my-auto mx-8 font-bold">
                  NIRANKARI RAJMATA KULWANT KAUR JI
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                An epitome of motherly love, compassion, unflinching devotion
                and integrity. Nirankari Rajmata Kulwant Kaur ji was an
                exemplary saint who lived up to each role and responsibility
                bestowed unto her with profoundness. She had spiritual
                inclination and seeking right from her childhood, and was
                blessed with God-Knowledge at a tender age of 8 years by
                Shahenshah Baba Avtar Singh. Rajmata Kulwant ji spent her life
                in complete acceptance of the divine will. She was married to
                Gurbachan Singh Ji, who later became the third Satguru of the
                Mission. She spread the message of the Nirankari Mission,
                following the footsteps of all her masters fearlessly, giving
                the clarion call not only through words, but also with actions.
                She upheld reverence towards her satguru above all worldly
                relations, along with maintaining humility in behaviour. Her
                contributions towards mankind were acknowledged through various
                honours and awards. Her historical songs and poems will remain
                etched in the memory of devotees for many eras to follow, as
                sublime messages of true devotion.
              </p>

              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex mt-10">
                <img
                  src="image/lagacy/Baba-Hardev-Singh-Ji-Blue.jpg"
                  alt="s"
                ></img>
                <h3 className="my-auto mx-8 font-bold">
                  BABA HARDEV SINGH JI MAHARAJ (23rd FEB 1954 – 13th MAY 2016)
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                As an ambassador of peace and truth, Baba Hardev Singh Ji
                undertook numerous salvation tours across India and overseas.
                His unique messages like peaceful co-existence, a world without
                walls and harmony in oneness etc. Not only impressed everyone,
                but also changed the lives of many. Recognizing the widespread
                impact of Baba Ji’s teachings, the United Nations (U.N.O.)
                honored the Sant Nirankari Mission with special consultative
                status in 2012, which was later upgraded to general consultative
                status in 2018. A messiah of divinity and humanness, Baba Hardev
                Singh Ji can unequivocally be described as pure personification
                of love. His magnanimity, simplicity, ingenuity and tenacity
                gave the mission a multi-dimensional outreach. His mesmerizing
                smile, divine attraction, sweet words, compassionate heart,
                humble nature and unconditional forgiveness will remain etched
                as an indelible memory in the hearts and minds of generations to
                come. The mankind lost his physical form on 13th May 2016 in an
                unfortunate accident.
              </p>
              {/* BABA AVTAR SINGH JI MAHARAJ  */}
              <div className="flex mt-10">
                <img src="image/lagacy/Mata-Savinder-Ji-Blue.jpg" alt="s"></img>
                <h3 className="my-auto mx-8 font-bold">
                  MATA SAVINDER HARDEV JI MAHARAJ (12th JAN 1957 – 5th AUG 2018){" "}
                </h3>
              </div>
              <p className="font-serif pr-14  text-[18px] pt-4">
                Mata Savinder Hardev Ji Maharaj was a brave, compassionate,
                humble and large-hearted soul since childhood. She was born and
                brought up in a family with values of devotion and humility.
                Savinder Ji walked the path of spirituality with complete faith
                and surrender. After being married to Hardev Singh ji, she
                fulfilled all her family and social duties with dignity,
                affection, simplicity and dedication. She accompanied Baba
                Hardev Singh Ji during his salvation tours for 36 years,
                spreading the message of love and peace across the world. On the
                sad and sudden departure of Baba Hardev Singh Ji in physical
                form, Mata Savinder Hardev Ji Maharaj manifested as the fifth
                Satguru of the Sant Nirankari Mission. Keeping aside her own
                physical and emotional pain, Satguru Mata Ji blessed millions of
                Nirankari devotees with her motherly warmth, providing them
                relief in extremely testing moments. She accepted the will of
                almighty God, and also preached same among the followers,
                inspiring them to carry forward the teachings of Gurudev Hardev
                and the divine message of the mission amongst the masses.
                Satguru Mata Ji took forward the spiritual journey of
                god-knowledge with great determination. Before merging in the
                formless Nirankar, Mata Savinder Ji embellished the divine seat
                of enlightenment by declaring Mata Sudiksha Ji Maharaj as the
                sixth Satguru of the mission. Satguru Mata Savinder Hardev Ji
                Maharaj will always be remembered in the history of mankind as a
                lighthouse of bliss and strength.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Lagacy;
